import { gql, TypedDocumentNode } from "@apollo/client";

import {
  QuerySearchPoliciesArgs,
  SearchPoliciesOutput,
  Policy,
  PolicyConnection,
} from "types/generated";

export type SearchPoliciesForNavigationItem = Pick<Policy, "id" | "name" | "spaceDetails">;

type SearchPoliciesForNavigationData = {
  searchPolicies: {
    edges: Array<{
      node: SearchPoliciesForNavigationItem;
      cursor: PolicyConnection["cursor"];
    }>;
    pageInfo: Pick<SearchPoliciesOutput["pageInfo"], "hasNextPage">;
  };
};

export const SEARCH_POLICIES_FOR_NAVIGATION: TypedDocumentNode<
  SearchPoliciesForNavigationData,
  QuerySearchPoliciesArgs
> = gql`
  query SearchPoliciesForNavigation($input: SearchInput!) {
    searchPolicies(input: $input) {
      edges {
        node {
          id
          name
          spaceDetails {
            id
            name
            accessLevel
          }
        }
        cursor
      }
      pageInfo {
        hasNextPage
      }
    }
  }
`;
